<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('currency.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('currency.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <Button type="info" ghost @click="addNew()">
            {{ $t('addNew') }}
          </Button>
          <div class="ts-justify-end">
            <Tooltip
              :content="$t('currency.search')"
              placement="top"
              transfer
              :max-width="width"
            >
              <Input
                search
                v-model="search"
                :placeholder="$t('currency.search')"
                :style="width"
                @on-focus="() => (width = 'width: 500px')"
                @on-blur="() => (width = 'width: 300px')"
              />
            </Tooltip>
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="is_default">
          <span
            class="badge bg-success tw-capitalize px-2 fs-12px d-inline-flex"
            v-if="row.is_default"
            >Yes
          </span>
          <span
            class="badge bg-danger tw-capitalize px-2 fs-12px d-inline-flex"
            v-else
            >No
          </span>
        </template>
        <template slot-scope="{ row }" slot="compare_to_default_currency">
          <span class="badge bg-info ts-capitalize px-2 d-inline-flex">
            <b>
              {{
                row.default_currency ? row.default_currency.currency_code : ''
              }}
              {{ row.compare_to_default_currency }} {{ row.currency_code }}
            </b>
          </span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            class="text-primary"
            @click.prevent="edit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('currency.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="500px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'exchangeRateIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('exchangeRate/currency', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeRate.currency.search
      },
      set(newValue) {
        this.$store.commit('exchangeRate/currency/SET_SEARCH', newValue)
        this.$store.commit('exchangeRate/currency/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('currency.code'),
          key: 'currency_code',
          fixed: 'left'
        },
        {
          title: this.$t('currency.description'),
          key: 'currency_description'
        },
        {
          title: this.$t('currency.symbol'),
          key: 'currency_symbol',
          align: 'center'
        },
        {
          title: this.$t('currency.minimumCashDenomination'),
          key: 'minimum_cash_denomination',
          align: 'center'
        },
        {
          title: this.$t('currency.rounding'),
          key: 'currency_rounding',
          align: 'center'
        },
        {
          title: this.$t('currency.default'),
          slot: 'is_default',
          align: 'center'
        },
        {
          title: this.$t('currency.compareToDefaultCurrency'),
          slot: 'compare_to_default_currency',
          align: 'center'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 90
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currency/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('exchangeRate/currency/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('exchangeRate/currency/SET_EDIT_DATA', {})
      this.showForm = false
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('exchangeRate/currency/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
